var _g, _g2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12480_150780)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 44,
    height: 44,
    rx: 10,
    fill: "url(#paint0_linear_12480_150780)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.25,
    width: 43.5,
    height: 43.5,
    rx: 9.75,
    stroke: "#E6E1E5",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12480_150780)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0602 16.118C31.0602 20.5691 27.4519 24.1774 23.0008 24.1774C18.5497 24.1774 14.9414 20.5691 14.9414 16.118C14.9414 11.6669 18.5497 8.05859 23.0008 8.05859C27.4519 8.05859 31.0602 11.6669 31.0602 16.118ZM23.5282 11.5128V13.8687L26.5389 17.2861H23.5282V18.7489H27.8273L28.6138 17.2861L23.5282 11.5128ZM19.4303 17.2862H22.44V18.749H18.1419L17.3544 17.2862L21.9468 12.0729L22.44 11.5129V13.8688L19.4303 17.2862Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9954 34.1967H14.874L14.4427 32.9342H12.4588L12.0275 34.1967H10.9219L12.8117 29.0212H14.1056L15.9954 34.1967ZM12.7019 32.1344H14.1997L13.4469 29.876L12.7019 32.1344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0358 34.2751C17.7117 34.2751 17.4215 34.1941 17.1654 34.032C16.9144 33.87 16.7158 33.6373 16.5694 33.3341C16.4283 33.0309 16.3577 32.6676 16.3577 32.2441C16.3577 31.8102 16.4335 31.4417 16.5851 31.1385C16.7367 30.83 16.9406 30.5974 17.1967 30.4406C17.4581 30.2785 17.7509 30.1975 18.075 30.1975C18.42 30.1975 18.7049 30.2968 18.9297 30.4955C19.1545 30.6941 19.3009 30.9503 19.3689 31.2639L19.2669 31.3894V28.5586H20.3412V34.1967H19.3767L19.3061 33.0048L19.4394 33.0675C19.4028 33.3132 19.3192 33.5275 19.1885 33.7105C19.0578 33.8883 18.8931 34.0268 18.6945 34.1261C18.4958 34.2254 18.2763 34.2751 18.0358 34.2751ZM18.3494 33.4517C18.5376 33.4517 18.6997 33.4047 18.8356 33.3106C18.9715 33.2113 19.0761 33.0675 19.1493 32.8793C19.2277 32.6911 19.2669 32.4663 19.2669 32.2049C19.2669 31.954 19.2303 31.7423 19.1571 31.5698C19.0839 31.392 18.9794 31.2561 18.8435 31.162C18.7075 31.0679 18.5481 31.0209 18.3651 31.0209C18.0724 31.0209 17.8424 31.1254 17.6751 31.3345C17.513 31.5384 17.432 31.839 17.432 32.2363C17.432 32.6336 17.513 32.9368 17.6751 33.1459C17.8371 33.3498 18.0619 33.4517 18.3494 33.4517Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.47 34.1967V30.2759H22.4345L22.4738 30.9816C22.6044 30.7203 22.7822 30.5242 23.007 30.3935C23.237 30.2628 23.4905 30.1975 23.7676 30.1975C24.0499 30.1975 24.3035 30.2628 24.5282 30.3935C24.7583 30.5242 24.9308 30.7176 25.0458 30.9738C25.1294 30.8013 25.2418 30.6575 25.383 30.5425C25.5241 30.4275 25.681 30.3412 25.8535 30.2837C26.026 30.2262 26.2011 30.1975 26.3789 30.1975C26.635 30.1975 26.8677 30.2498 27.0768 30.3543C27.2911 30.4589 27.461 30.6157 27.5865 30.8248C27.7119 31.0339 27.7747 31.3005 27.7747 31.6247V34.1967H26.7004V31.8364C26.7004 31.5489 26.6376 31.345 26.5122 31.2247C26.3867 31.1045 26.2246 31.0444 26.026 31.0444C25.8692 31.0444 25.7228 31.0836 25.5869 31.162C25.4562 31.2404 25.3516 31.358 25.2732 31.5149C25.2 31.6665 25.1634 31.8573 25.1634 32.0873V34.1967H24.0891V31.8364C24.0891 31.5489 24.0238 31.345 23.8931 31.2247C23.7676 31.1045 23.6056 31.0444 23.4069 31.0444C23.271 31.0444 23.1351 31.081 22.9991 31.1542C22.8684 31.2273 22.7587 31.3424 22.6698 31.4992C22.5861 31.656 22.5443 31.8625 22.5443 32.1187V34.1967H21.47Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4238 29.7113C29.1991 29.7113 29.0318 29.6643 28.922 29.5702C28.8122 29.4708 28.7573 29.3271 28.7573 29.1389C28.7573 28.9454 28.8122 28.8017 28.922 28.7076C29.0318 28.6083 29.1991 28.5586 29.4238 28.5586C29.6486 28.5586 29.8159 28.6083 29.9257 28.7076C30.0355 28.8017 30.0904 28.9454 30.0904 29.1389C30.0904 29.3271 30.0355 29.4708 29.9257 29.5702C29.8159 29.6643 29.6486 29.7113 29.4238 29.7113ZM29.9571 30.2759V34.1967H28.8828V30.2759H29.9571Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0959 34.1967V30.2759H32.0604L32.1231 31.4521L31.9898 31.3267C32.0526 31.0705 32.1519 30.8588 32.2878 30.6915C32.4237 30.5242 32.5884 30.4014 32.7818 30.323C32.9805 30.2393 33.1974 30.1975 33.4327 30.1975C33.7045 30.1975 33.945 30.2498 34.1541 30.3543C34.3684 30.4589 34.5357 30.6183 34.656 30.8327C34.7814 31.0418 34.8442 31.3058 34.8442 31.6247V34.1967H33.7699V31.9305C33.7699 31.5959 33.7045 31.3659 33.5738 31.2404C33.4431 31.1097 33.2732 31.0444 33.0641 31.0444C32.9177 31.0444 32.774 31.081 32.6328 31.1542C32.4969 31.2221 32.3845 31.3345 32.2956 31.4913C32.212 31.6482 32.1702 31.8573 32.1702 32.1187V34.1967H31.0959Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12480_150780",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12480_150780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12480_150780",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12480_150780",
    x: 13.9414,
    y: 8.05859,
    width: 18.1172,
    height: 18.1172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12480_150780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12480_150780",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12480_150780",
    x1: 3.40625,
    y1: 2.40625,
    x2: 41.5625,
    y2: 42.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C94B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.4b8e8b487668ddd79c5feeb93a187321.svg";
export { ForwardRef as ReactComponent };